import { Navigate, useParams } from 'react-router';
import { inferRouteObject } from 'react-router-typed-object';

import { or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import AppConfig from 'src/scenes/AppConfig';
import Status from 'src/scenes/Status';

const index = true;

const PublishersRedirect = () => {
  const { '*': splat } = useParams();
  return <Navigate to={`../publishers-configs/${splat ?? ''}`} replace />;
};

export const appConfigRouteObject = inferRouteObject({
  path: 'app-config',
  element: <PrivateRoute roles={or(Roles.ADMIN, Roles.HEADER_TAG)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AppConfig.Helmet,
      children: [
        {
          index,
          element: <Navigate to='./publishers-configs' replace />,
        },
        {
          path: 'publishers-configs',
          children: [
            { index, Component: AppConfig.PublishersConfigsList },
            { path: 'create', Component: AppConfig.PublisherConfigForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':publisherId', Component: AppConfig.PublisherConfigForm },
              ],
            },
            {
              path: ':publisherId',
              children: [
                { index, Component: AppConfig.PublisherConfigDetails },
                {
                  path: 'ad-config',
                  children: [
                    {
                      index,
                      Component: AppConfig.AdConfigForm,
                    },
                    {
                      path: ':adConfigId',
                      Component: AppConfig.AdConfigForm,
                    },
                  ],
                },
              ],
            },
          ],
        },
        // TODO remove after 28.02.2026
        { path: 'publishers/*', element: <PublishersRedirect /> },
        { path: '*', element: <Navigate to='./publishers-configs' replace /> },
      ],
    },
  ],
});
